import { useContext } from "react";
import { KBContext } from "../..";

import { isFeatureEnabled } from "../../../utils";
import { FTR_SUB_CATEGORIES } from "../../../Constants";

export const useSubCategoriesFeature = () => {

    const { data, availableFeatures } = useContext(KBContext);

    // disabling this feature for non-gmail tenants
    const isTenantEnabled = data?.tenant === 'gmail';

    const isSubCategoriesFeatureEnabled = isTenantEnabled && isFeatureEnabled(FTR_SUB_CATEGORIES, availableFeatures);

    return { isSubCategoriesFeatureEnabled };
}